exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.save-margin[data-v-e4a0db6c]{margin-bottom:55px;padding-bottom:env(safe-area-inset-bottom)}}.title-wishlist[data-v-e4a0db6c]{font-size:36px}@media (max-width: 767px){.title-wishlist[data-v-e4a0db6c]{font-size:20px}}.link-box[data-v-e4a0db6c]{display:inline}.close-wishlist[data-v-e4a0db6c]{right:40px}@media (max-width: 767px){.close-wishlist[data-v-e4a0db6c]{right:20px}}\n", ""]);

// exports
